<script setup lang="ts">
import { StoreName } from '~/interfaces/network'
import IconStar from '~/components/Icons/IconStar.vue'
import { getAppStoreChargemapUrl, getPlayStoreChargemapUrl } from '~/utils/url'

export interface Props {
    locale: string
    storeName: StoreName | ''
}

const props = withDefaults(defineProps<Props>(), {
    locale: '',
    storeName: ''
})

const config = useRuntimeConfig()

const imagePath = computed(() => {
    switch (props.storeName) {
        case StoreName.AppStore:
            return `${config.app.cdnURL}/images/cmp-store/${props.locale}/app-store-badge.svg`
        case StoreName.GooglePlay:
            return `${config.app.cdnURL}/images/cmp-store/${props.locale}/google-play-badge.png`
        default:
            return ''
    }
})

const imageUrl = computed(() => {
    switch (props.storeName) {
        case StoreName.AppStore:
            return getAppStoreChargemapUrl(props.locale)
        case StoreName.GooglePlay:
            return getPlayStoreChargemapUrl(props.locale)
        default:
            return ''
    }
})

const gtmClass = computed(() => {
    switch (props.storeName) {
        case StoreName.AppStore:
            return 'gtm-AppStore'
        case StoreName.GooglePlay:
            return 'gtm-GooglePlay'
        default:
            return ''
    }
})

const rating = computed(() => {
    switch (props.storeName) {
        case StoreName.AppStore:
            return 4.7
        case StoreName.GooglePlay:
            return 4.6
        default:
            return 0
    }
})
</script>

<template>
    <div class="flex flex-col justify-center items-center gap-1">
        <a
            target="_blank"
            :class="gtmClass"
            :href="imageUrl"
            :title="$t('home.download.' + storeName)"
        >
            <img :src="imagePath" :alt="$t('home.download.' + storeName)" />
        </a>
        <div class="flex justify-center items-center gap-1">
            <div class="flex justify-center items-center">
                <IconStar full />
                <IconStar full />
                <IconStar full />
                <IconStar full />
                <IconStar half />
            </div>
            <span
                v-if="rating"
                class="text-sky-600 text-base font-medium font-inter leading-tight"
            >
                {{ rating }}
            </span>
        </div>
    </div>
</template>
